import { Store } from '@betgames/bg-state-manager';
import SessionStore from '@bg-shared/business/Session/Session.store';
import { webAPIIntegration } from '@bg-shared/integrations/WebIntegration/webAPIIntegration';
import { IBGIWebIntegration } from '@bg-shared/integrations/WebIntegration/interfaces';
import { partnerSettingsStore } from '@bg-shared/business/PartnerSettings';
import { IPromotionsModel, IPromotionPayout } from './interfaces';
import PromotionsApi from './Promotions.api';

export default class PromotionsStore extends Store<IPromotionsModel> {
    constructor(
        private readonly repository: PromotionsApi,
        private readonly sessionStore: SessionStore,
    ) {
        super({
            key: 'Promotions',
            default: {
                promotions: null,
                promotionPayouts: [],
            },
        });
    }

    private initEvents(): void {
        this.repository.subscribePromotions((data) => {
            if (!data) {
                return;
            }

            if (!this.value.promotions.currencyRates?.[data.currencyCode]) {
                this.repository.fetchPromotion(this.sessionStore.partnerCode).then((response) => {
                    this.update((draft) => {
                        draft.promotions.currencyRates = response.currencyRates;
                    });
                });
            }

            this.update((draft) => {
                const existingPromotionIndex = draft.promotions.active.findIndex(
                    (promo) => promo.id === data.id,
                );

                if (existingPromotionIndex === -1) {
                    draft.promotions.active.push(data);
                } else {
                    Object.assign(draft.promotions.active[existingPromotionIndex], data);
                }
            });
        });

        this.repository.subscribePromotionsPayout((data) => {
            webAPIIntegration<IBGIWebIntegration>(
                partnerSettingsStore.webIntegrationType,
                (api) => {
                    api.jackpotWinUpdate(data.amount);
                },
            );
            this.updatePromotionPayout(data);
        });
    }

    public init(): void {
        this.repository.fetchPromotion(this.sessionStore.partnerCode).then((promotions) => {
            this.update((draft) => {
                draft.promotions = promotions;
            });

            this.initEvents();
        });
    }

    public updatePromotionPayout(promotionPayout: IPromotionPayout): void {
        if (!promotionPayout) {
            return;
        }

        this.update((draft) => {
            const existingPromotionPayoutIndex = draft.promotionPayouts.findIndex(
                (payOut) => payOut.id === promotionPayout.id,
            );

            if (existingPromotionPayoutIndex === -1) {
                draft.promotionPayouts.push(promotionPayout);
            } else {
                Object.assign(
                    draft.promotionPayouts[existingPromotionPayoutIndex],
                    promotionPayout,
                );
            }
        });
    }
}
